<template>
  <div
    class="container-increment display-flex flex-direction-row"
  >
    <div class="input">
      <input
        data-testid="ucinputincrement-input"
        type="number"
        :value="valor"
        inputmode="numeric"
        @change="InputChange($event.target.value)"
      >
    </div>
    <div>
      <div
        data-testid="ucinputincrement-increment"
        @click="Increment"
      >
        <img
          alt="iconUp"
          src="@/static/icons/ic_up_02.svg"
        >
      </div>
      <div
        data-testid="ucinputincrement-decrement"
        @click="Decrement"
      >
        <img
          alt="iconDown"
          src="@/static/icons/ic_down2.svg"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    val: {
      type: Number,
      default: 0,
    },
    maxValor: {
      type: Number,
      required: true,
    },
  },

  emits: ['value'],

  data() {
    return {
      valor: null,
    };
  },

  watch: {
    val(val) {
      this.valor = val;
    },
  },

  mounted() {
    this.StartComponent();
    this.EventValor();
  },

  methods: {
    StartComponent() {
      this.valor = this.val;
    },

    /**
     * @public
     * @returns {number} The value of the input.
     */
    GetValue() {
      return Number(this.valor);
    },

    Increment() {
      if (this.valor < this.maxValor) {
        const valParse = Number.parseInt(this.valor, 10);
        this.valor = valParse + 1;
        this.EventValor();
      }
    },

    Decrement() {
      if (this.valor > 0) {
        this.valor -= 1;
        this.EventValor();
      }
    },

    InputChange(value) {
      if (value === '') {
        this.valor = null;
        this.valor = 0;
      } else if (value < 0) {
        this.valor = null;
        this.valor = 0;
      } else if (value > this.maxValor) {
        this.valor = null;
        this.valor = this.maxValor;
      } else {
        this.valor = value;
      }

      this.EventValor();
    },

    EventValor() {
      this.$emit('value', Number(this.valor));
    },
  },

});
</script>

<style scoped lang="scss">
.container-increment {
  box-sizing: border-box;
  background: var(--his-tierra-white);
  border: 1px solid var(--his-silver);
  border-radius: 6px;
  color: var(--his-steel-blue);
  max-height: 46px;

  .input {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: #324567;

    input {
      height: 100%;
      text-align: center;
    }
  }
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
